import { GlobalOutlined, LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import imageUploadIcon from 'assets/image-upload-icon.svg';
import styles from './WebsiteScreenshot.module.css';
import { Skeleton } from 'antd';

type Props = {
  websiteURL: string;
  src: string;
  canResolve?: boolean;
  css?: {
    container?: string;
    image?: string;
  };
};

export const WebsiteScreenshot = ({
  websiteURL,
  src,
  css,
  canResolve,
}: Props) => {
  const [isImageErrored, setIsImageErrored] = useState(false);
  const [isImageValid, setIsImageValid] = useState(false);

  return (
    <div
      className={classNames(styles.container, css?.container, {
        [styles.noPadding]: !isImageErrored && isImageValid && canResolve,
      })}
    >
      {!isImageErrored && canResolve && (
        <img
          src={src}
          alt="screenshot"
          onLoad={() => setIsImageValid(true)}
          onError={() => setIsImageErrored(true)}
          className={classNames(styles.image, css?.image)}
        />
      )}
      {(isImageErrored || !isImageValid || !canResolve) && (
        <>
          <LoadingOutlined className={styles.loading} />
          <div className={styles.fallback}>
            <div className={styles.text}>
              We couldn’t take a screenshot of your website
            </div>
            <div className={classNames(styles.websiteBlock, styles.text)}>
              <GlobalOutlined className={styles.icon} />
              {websiteURL}
            </div>
            <Skeleton active />
            <div className={styles.emptyImage}>
              <img src={imageUploadIcon} className={styles.imageIcon} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
